import ApiService from '@/common/api.service'
import AclService from '@/common/acl.service'

export default {
  state: {
    entity: null,
    entityTypesEnum: {
      UNIVERSITY: 1,
      SCHOOL: 2,
      DEPARTMENT: 3,
      MANAGEMENT: 4,
      STUDENTS: 5,
      JOURNAL: 6,
    },
    lang: localStorage.getItem('language') || 'ar',
  },
  getters: {
    entity(state) {
      return state.entity
    },
    entityType(state, getters) {
      return getters.getEntityType(state.entity.type)
    },
    entityTypesEnum(state) {
      return state.entityTypesEnum
    },
    getEntityType(state) {
      return type => {
        const enumType = Object.entries(state.entityTypesEnum).find(enumType => enumType[1] === type)
        return enumType ? enumType[0].toLowerCase() : 'unknown'
      }
    },
    subEntities(state) {
      return state.entity?.children
    },
    flatEntities(state) {
      const entities = []
      function flat(entity) {
        if (entity.children) {
          entity.children.forEach(e => flat({ ...e }))
          delete entity.children
        }
        entities.push(entity)
      }
      flat({ ...state.entity })
      return entities
    },
    schools(state, getters) {
      return getters.flatEntities.filter(e => e.type === state.entityTypesEnum.SCHOOL)
    },
    departments(state, getters) {
      return getters.flatEntities.filter(e => e.type === state.entityTypesEnum.DEPARTMENT)
    },
    entityById(state, getters) {
      return id => {
        return getters.flatEntities.find(entity => entity.id === id)
      }
    },
  },
  mutations: {
    setEntity(state, entity) {
      state.entity = translateEntities(entity, state.lang)

      function translateEntities(entity, lang) {
        entity.title = entity.title[lang] || Object.values(entity.title).find(value => value)

        if (entity.children) {
          entity.children.map(sub_entity => {
            return translateEntities(sub_entity, lang)
          })
        }

        return entity
      }
    },
  },
  actions: {
    getCurrentEntity({ commit, getters, state }, payload) {
      if (state.entity && !payload?.force) return Promise.resolve(state.entity)
      return new Promise((resolve, reject) => {
        ApiService.query('entities')
          .then(({ data }) => {
            commit('setEntity', data)
            AclService.setLevel(getters.entityType)
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
